// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

body {
  font-family: Arial, Helvetica, sans-serif;
  overflow-x: hidden;
  padding: 0 !important;
  margin: 0 !important;
}

#root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

#agenda,
#speakers,
#contacts {
  scroll-margin-top: var(--navbar-height-mobile);
}
@media (min-width: 1200px) {
  #agenda,
  #speakers,
  #contacts {
    scroll-margin-top: var(--navbar-height-desktop);
  }
}

.not-yet-animated {
  visibility: hidden !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/index.scss"],"names":[],"mappings":"AAEA;EACI,sBAAA;AADJ;;AAIA;EACI,yCAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;AADJ;;AAIA;EACI,iBAAA;EACA,aAAA;EACA,sBAAA;AADJ;;AAIA;;;EAGI,8CAAA;AADJ;AAGI;EALJ;;;IAMQ,+CAAA;EAEN;AACF;;AACA;EACI,6BAAA;AAEJ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
